export default "__VITE_ASSET__D7SQ9uqf__"